import React from 'react'
import ForgotPasswordForm from 'shared/components/Forms/ForgotPasswordForm'
import SignupContainer from 'views/SignupContainer'

const ForgotPassword = () => {
  return (
    <SignupContainer>
      <ForgotPasswordForm />
    </SignupContainer>
  )
}

export default ForgotPassword